import { Box, Flex, Image, Text } from "@chakra-ui/react";
import SearchIcon from "@assets/icons/search-icon.svg";

const SearchingLoader = ({ title }: ISearchingLoader) => {
  return (
    <Flex>
      <Flex
        border={"1px solid #E6E9EF"}
        boxShadow={"0px 10px 10px 0px #0000001A"}
        borderRadius={"20px"}
        padding={"6px 14px"}
        gap={"8px"}
        alignItems={"center"}
      >
        <Image src={SearchIcon} alt="search-icon" />
        <Text fontWeight={500} fontSize={"14px"} color={"#0D0D0D"}>
          {title}
        </Text>
        <Box className="dotLoader" />
      </Flex>
    </Flex>
  );
};

export default SearchingLoader;
